// parallax scehe for header? https://codepen.io/GreenSock/pen/e785396ee2b11ab85d33b4bebdd4997f?editors=0010

// Begin when all assets are loaded and ready
window.addEventListener("load", function () {
    startAnimationArStatic();
});
startAnimationArStatic = function () {

    //set up scroll trigger - now registered in root site
    //gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.defaults({
        //markers: true
    });

    //set up mobile detection
    //can use one block for each or switch properties based on conditions
    let mm = gsap.matchMedia();
    mm.add({
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)",
    }, (context) => {

        let { isMobile, isDesktop } = context.conditions;

        //window.scrollY = 1000;
        let hasScrolled = (window.scrollY == 0) ? false : true;
        //console.log("hasScrolled", hasScrolled);

        // SLIDE COVER

        // PRELOADER

        let tlPreload = gsap.timeline({
            defaults: {
                duration: 0.6,
                ease: "power2.in"
            },
            onComplete: function () {
                //console.log('Preload complete');
                //gsap.to(window, { duration: 2, scrollTo: { y: "#slide-cover", offsetY: 50 } });
                //tlCover.to(window, {
                //    duration: 5,
                //    scrollTo: {
                //        y: "#slide-cover",
                //        offsetY: 0
                //    },
                //    ease: "power2.inOut"
                //}, "+=5")
                if (isMobile) {
                    //start the animation as there is no scrolltrigger on mobile
                    tlCover.resume();
                }
                else {
                    //push window into scrolltrigger to start first snap
                    //only if window is still at top of scroll pos, otherwise we might already be further down the page and get dragged backup
                    if ((window.scrollY == 0)) {
                        
                        gsap
                            .to(window, {
                                duration: 1,
                                delay: 1,
                                scrollTo: {
                                    y: "#slide-cover",
                                    offsetY: -5
                                },
                                ease: "power2.inOut"
                            });
                    }
                }
            }
        });

        tlPreload
            .to(".preloader__spinner", { duration: 1, opacity: 0 })
            .to(".preloader__text", { duration: 0.5, opacity: 0 }, "-=0.25")
            .to("#preloader", { duration: 1, opacity: 0, display: "none" }, "-=0.25");

        //starburst rotation
        gsap.to("#starburst-inner", 100, { rotation: "360", ease: Linear.easeNone, repeat: -1 });
        gsap.to("#starburst-mid", 130, { rotation: "360", ease: Linear.easeNone, repeat: -1 });
        gsap.to("#starburst-outer", 160, { rotation: "360", ease: Linear.easeNone, repeat: -1 });

        //var tlRingInner = gsap.timeline({ paused: true, repeat: -1 });
        //tlRingInner.to("#ring-inner", 15, { rotation: "+=360", ease: Linear.easeNone });

        //var tlRingOuter = gsap.timeline({ paused: true, repeat: -1 });
        //tlRingOuter.to("#ring-outer", 20, { rotation: "+=360", ease: Linear.easeNone });

        //let triggerElement = $(this);
        //let targetElement = $("#cefc-starburst");

        let tlCover;

        if (isDesktop) {

            tlCover = gsap.timeline({
                scrollTrigger: {
                    //id: triggerElement.attr('id'),
                    trigger: "#slide-cover",
                    // trigger element - viewport
                    start: "1 top",
                    end: "75% bottom",
                    scrub: 1,
                    snap: { snapTo: "labelsDirectional", delay: 0.1, duration: { min: 0.2, max: 2 } },
                    //markers: true
                },
                defaults: {
                    duration: 1,
                    //ease: "power2.in"
                },
                paused: true
            });

            tlCover
                //starburst in
                .fromTo("#ring-inner, #ring-outer, #starburst-inner, #starburst-mid, #starburst-outer", {
                    scale: 0,
                    opacity: 0,
                    transformOrigin: "center center"
                },
                    {
                        scale: 0.95,
                        opacity: 1,
                        stagger: 0.5,
                        transformOrigin: "center center"
                    }
                )

                .from("#text-new-capital", {
                    opacity: 0,
                    duration: 5
                })
                .addLabel("new capital")
                .to("#text-new-capital", {
                    opacity: 0,
                    duration: 5
                }, "+=5")

                //.addLabel("starburst bounce up")
                .to("#starburst-inner, #starburst-mid, #starburst-outer, #ring-inner, #ring-outer", {
                    scale: 1,
                    //opacity: 0,
                    stagger: 0.1,
                    transformOrigin: "center center",
                    duration: 5
                }, "<")


                //.addLabel("starburst bounce down")
                .to("#ring-inner, #ring-outer,  #starburst-inner, #starburst-mid, #starburst-outer", {
                    scale: 0.95,
                    //opacity: 0,
                    stagger: 0.1,
                    transformOrigin: "center center",
                    duration: 20
                })

                //.addLabel("background tunnel out")
                .to("#background-frame", {
                    "--clip": "0%",
                    duration: 8
                }, "-=5")

                //.addLabel("ring transition")
                .to("#ring-inner", {
                    rotation: "+=520",
                    ease: Power4.easeInOut,
                    duration: 15,
                    //onComplete: tlRingInner.to("#ring-inner", 15, { rotation: "+=360", ease: Linear.easeNone }),
                })

                .to("#ring-outer", {
                    rotation: "+=380",
                    ease: Power4.easeInOut,
                    duration: 10,
                    //onComplete: tlRingOuter.play(),
                }, "<")

                .from("#text-allocation", {
                    opacity: 0,
                    duration: 3,
                })
                .addLabel("allocation")
                ;


        } else {

            //isMobile

            tlCover = gsap.timeline({
                defaults: {
                    duration: 1,
                    //ease: "power2.in"
                },
                paused: true
            });
            //console.log(window.scrollY == 0);
            //console.log(hasScrolled);
            tlCover
                .to(window, {
                    duration: 5,
                    scrollTo: !hasScrolled ? { y: "#slide-cover", offsetY: 56, autoKill: true } : false,
                    ease: "power2.inOut",
                    delay: 1
                }, "+=5")
                //starburst in
                .fromTo("#ring-inner, #ring-outer, #starburst-inner, #starburst-mid, #starburst-outer", {
                    scale: 0,
                    opacity: 0,
                    transformOrigin: "center center"
                },
                    {
                        scale: 0.95,
                        opacity: 1,
                        stagger: 0.5,
                        transformOrigin: "center center"
                    }
                )

                .from("#text-new-capital", {
                    opacity: 0,
                    duration: 5
                })
                .addLabel("new capital")
                .to("#text-new-capital", {
                    opacity: 0,
                    duration: 5
                }, "+=5")

                //.addLabel("starburst bounce up")
                .to("#starburst-inner, #starburst-mid, #starburst-outer, #ring-inner, #ring-outer", {
                    scale: 1,
                    //opacity: 0,
                    stagger: 0.1,
                    transformOrigin: "center center",
                    duration: 5
                }, "<")


                //.addLabel("starburst bounce down")
                .to("#ring-inner, #ring-outer,  #starburst-inner, #starburst-mid, #starburst-outer", {
                    scale: 0.95,
                    //opacity: 0,
                    stagger: 0.1,
                    transformOrigin: "center center",
                    duration: 5
                })

                //.addLabel("background tunnel out")
                .to("#background-frame", {
                    "--clip": "0%",
                    duration: 8
                }, "-=5")

                //.addLabel("ring transition")
                .to("#ring-inner", {
                    rotation: "+=520",
                    ease: Power4.easeInOut,
                    duration: 15,
                    //onComplete: tlRingInner.to("#ring-inner", 15, { rotation: "+=360", ease: Linear.easeNone }),
                })

                .to("#ring-outer", {
                    rotation: "+=380",
                    ease: Power4.easeInOut,
                    duration: 10,
                    //onComplete: tlRingOuter.play(),
                }, "<")

                .from("#text-allocation", {
                    opacity: 0,
                    duration: 3,
                })
                .addLabel("allocation")
                .to(window, {
                    duration: 10,
                    scrollTo: {
                        y: "#intro-text",
                        offsetY: 50
                    },
                    ease: "power2.inOut"
                }, "+=10");

            tlCover.duration(10);

        }


        

        if (isMobile) {
            //accellerate on mobile
            
        }

        


        //SLIDE TRANSACTIONS
        let transactionSections = gsap.utils.toArray("#transaction-carousel .horizontal-slide");

        //mobile only
        if (isDesktop) {
            gsap.to(transactionSections, {
                xPercent: -100 * (transactionSections.length - 1),
                ease: "none",
                scrollTrigger: {
                    trigger: "#slide-transactions",
                    pin: isMobile ? false : true,
                    //pinSpacing: false
                    //pinSpacing: "margin",
                    scrub: 1,
                    snap: isMobile ? false : { snapTo: 1 / (transactionSections.length - 1), duration: { min: 0.2, max: 1 }, delay: 0.1, },
                    // base vertical scrolling on how wide the container is so it feels more natural.
                    end: "+=3500",
                }
            });
        }

        //SLIDE VIDEO
        let video = document.getElementById("video");
        //let triggerElement = $(this);
        //let targetElement = $("#cefc-starburst");
        let tlVideo = gsap.timeline({
            scrollTrigger: {
                id: 'video player',
                //trigger: triggerElement,
                // trigger element - viewport
                start: "10% bottom",
                //end: "top top",
                trigger: "#video",
                //endTrigger: "#video-end-trigger",
                //scrub: 1,
                //onEnter: () => {
                //    video.play();
                //    console.log("play");
                //},
                //onLeave: () => {
                //    video.pause();
                //    console.log("pause");
                //},
                onToggle: self => self.isActive ? video.play() : video.pause(),
                //markers: true
            },
            defaults: {
                //duration: 1,
                //ease: "power2.in"
            }
        });

        //let video = document.getElementById("video");
        //let triggerElement = $(this);
        //let targetElement = $("#cefc-starburst");
        //let tlVideoForeground = gsap.timeline({
        //    scrollTrigger: {
        //        //id: triggerElement.attr('id'),
        //        trigger: video,
        //        // trigger element - viewport
        //        start: "top center",
        //        //end: "90% bottom",
        //        //scrub: 1,
        //        //markers: true
        //    },
        //    defaults: {
        //        duration: 0.5,
        //        //ease: "power2.in"
        //    }
        //});
        //tlVideoForeground
        //    //starburst in
        //    .fromTo("#video-text-new-capital", {
        //        scale: 0,
        //        opacity: 0,
        //        transformOrigin: "center center"
        //    },
        //        {
        //            scale: 0.95,
        //            opacity: 1,
        //            stagger: 0.5,
        //            transformOrigin: "center center"
        //        }
        //    )
        //    .fromTo("#video-text-allocation", {
        //        scale: 0,
        //        opacity: 0,
        //        transformOrigin: "center center"
        //    },
        //        {
        //            scale: 0.95,
        //            opacity: 1,
        //            stagger: 0.5,
        //            transformOrigin: "center center"
        //        }
        //    );


        // SLIDE CHAIR

        //let triggerElement = $(this);
        //let targetElement = $("#slide-chair .pinned-background");

        let tlChair = gsap.timeline({
            scrollTrigger: {
                //id: triggerElement.attr('id'),
                trigger: "#slide-chair",
                // trigger element - viewport
                start: "top 80%",
                //end: "20%",
                scrub: 10
            }
        });
        //tlChair.from("#slide-chair .pinned-background", {
        //    rotate: -40,
        //    //opacity: 0,
        //    //duration: 1

        //});


        
        //side images
        $(".ar-side-image-variant-block__image-container").each(function (index) {
            let triggerElement = $(this);
            let targetElement = $(this);;

            let tl = gsap.timeline({
                scrollTrigger: {
                    id: triggerElement.attr('id'),
                    trigger: triggerElement,
                    // trigger element - viewport
                    start: "top 80%",
                    //end: "20%",
                    //scrub: 10
                }
            });
            tl.from(targetElement, {
                opacity: 0,
                //duration: 1

            });
        });


        //SLIDE DOWNLOAD

        //consider smoothscroll

        //https://codepen.io/GreenSock/pen/QWjjYEw


        //OLD

        // facts
        //$("#pine-numbers-block").each(function (index) {
        //    let triggerElement = $(this);
        //    let targetElement = $(".ar-facts-block__facts-container");

        //    let tl = gsap.timeline({
        //        scrollTrigger: {
        //            id: triggerElement.attr('id'),
        //            trigger: triggerElement,
        //            // trigger element - viewport
        //            start: "20% top",
        //            end: "20%",
        //            scrub: 1
        //        }
        //    });
        //    tl.from(targetElement, {
        //        y: "200px",
        //        opacity: 0,
        //        //duration: 1

        //    });
        //});


        // pinned background
        //$("#pine-numbers-block").each(function (index) {
        //    let triggerElement = $(this);
        //    let targetElement = $(".pinned-background");

        //    let tl = gsap.timeline({
        //        scrollTrigger: {
        //            id: triggerElement.attr('id'),
        //            trigger: triggerElement,
        //            // trigger element - viewport
        //            start: "top 80%",
        //            //end: "20%",
        //            scrub: 10
        //        }
        //    });
        //    tl.from(targetElement, {
        //        rotate: -40,
        //        //opacity: 0,
        //        //duration: 1

        //    });
        //});


        // white figure
        //$("#white-figure-block").each(function (index) {
        //    let triggerElement = $(this);
        //    let targetElement = $("#white-figure-block-svg");

        //    let tl = gsap.timeline({
        //        scrollTrigger: {
        //            id: triggerElement.attr('id'),
        //            trigger: triggerElement,
        //            // trigger element - viewport
        //            start: "20% top",
        //            end: "20%",
        //            scrub: 1
        //        }
        //    });
        //    tl.from(targetElement, {
        //        x: isMobile ? 0 : "-100%",
        //        opacity: 0,
        //        //duration: 15
        //    })
        //});


        // Multicolour
        //$("#multi-colour").each(function (index) {
        //    let triggerElement = $(this);
        //    let targetElement = $("#multi-colour");

        //    let tl = gsap.timeline({
        //        scrollTrigger: {
        //            id: triggerElement.attr('id'),
        //            trigger: triggerElement,
        //            // trigger element - viewport
        //            start: "20% top",
        //            end: "top top",
        //            scrub: 1
        //        }
        //    });
        //    tl.fromTo(targetElement, {
        //        //width: "50%",
        //        backgroundColor: "#f4f0ed"
        //    },
        //        {
        //            //width: "100%",
        //            backgroundColor: "#014846",
        //            color: "#ffffff",
        //            //duration: 100
        //        }
        //    );
        //});


    });


}

//$(function(){
    // loads when dom is ready, not window (all assets)
//});